import React from 'react';
import styles from './questionUsageBlock.module.scss';
import quest from '../../../assets/images/龍寶寶_babyDragon_messageQuestion.png'

const questionUsageBlock = () => (
  <div className={[styles.container].join(' ')}>
    <div className={[styles.textBlock, 'col-lg-6', 'col-12'].join(' ')}>
      <div className={[styles.textBlockInner].join(' ')}>
        <h2>你是不是出遊的時候，常常有算錢上的困擾呢？</h2>
      </div>
    </div>
    <div className={[styles.imgBlock, 'col-lg-6', 'col-12', 'px-0'].join(' ')}>
      <img src={quest} alt="龍寶寶使用疑問" />
    </div>
  </div>
)

export default questionUsageBlock;
